import { useAgency } from '@/contexts/AgencyContext'
import { usePageTitle } from '@/hooks/usePageTitle'

interface PublicLayoutProps {
  children: React.ReactNode
  pageTitle?: string
}

export const PublicLayout: React.FC<PublicLayoutProps> = ({ children, pageTitle }: PublicLayoutProps) => {
  const { agency } = useAgency()

  usePageTitle({
    agencyName: agency?.company_name,
    pageTitle
  })

  return <div className="w-full h-dvh">{children}</div>
}
